import React, { useState } from 'react';
import { useCustomer } from '../hooks/useCustomer';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Container, Box, Pagination, Alert, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function CustomerList() {
  const { customers, page, totalPages, setPage, setSearchQuery, error } = useCustomer();
  const [searchText, setSearchText] = useState<string>('');

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };


  const handleSearch = () => {
    setSearchQuery(searchText);
    setPage(1);
  };


  return (
    <Container>
      <h2>顧客管理</h2>
      <Box display="flex" justifyContent="space-between" mb={5}>
        <TextField
          variant="outlined"
          placeholder="顧客名で検索"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={handleSearch}>
                  <SearchIcon />
                </Button>
              </InputAdornment>
            ),
          }}
          sx={{ maxHeight: 10 }}
        />
      </Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>顧客コード</TableCell>
            <TableCell>ふりがな<br />名前</TableCell>
            <TableCell>住所</TableCell>
            <TableCell>電話番号<br />FAX</TableCell>
            <TableCell>メール<br />請求先コード</TableCell>
            <TableCell>備考</TableCell>
            <TableCell>最終更新日時</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {customers.map((customer, index) => (
            <TableRow key={index}>
              <TableCell>{customer.id}</TableCell>
              <TableCell>{customer.furigana}<br />{customer.name}</TableCell>
              <TableCell>
                📮{customer.postal_code}
                <br />
                {customer.address1}
                <br />
                {customer.address2 === "Empty" ? "": customer.address2}
              </TableCell>
              <TableCell>{customer.tel}<br />{customer.fax}</TableCell>
              <TableCell>{customer.mail}<br />{customer.billing_id}</TableCell>
              <TableCell>{customer.note}</TableCell>
              <TableCell>{customer.updated_at?.replace('T', ' ').split('+')[0]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination count={totalPages} page={page} onChange={handlePageChange} />
      </Box>
    </Container>
  );
}
